var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{attrs:{"title":_vm.$t('waterMark.tips2')}},[_c('div',{class:_vm.prefixCls},[_c('div',{class:_vm.prefixCls + '__body'},[_c('HaiUpload',{on:{"onChange":_vm.onChangeFile}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }